import { Table, Tag } from 'antd';
import { formatDate } from '../../utils/dateHelpers';

const MeetingsTable = ({ meetings, loading, showMember = false }) => {
  const columns = [
    ...(showMember
      ? [
          {
            title: 'Сотрудник',
            key: 'member',
            render: (_, record) => record.reportId?.teamMemberId?.fullName || '—',
          },
        ]
      : []),
    {
      title: 'Дата отчёта',
      key: 'fillDate',
      render: (_, record) =>
        formatDate(record.reportId?.fillDate || record.reportId?.createdAt),
    },
    {
      title: 'Менеджер',
      dataIndex: ['managerId', 'fullName'],
      key: 'manager',
    },
    {
      title: 'Выводы',
      dataIndex: 'summary',
      key: 'summary',
      ellipsis: true,
    },
    {
      title: 'След. встреча',
      dataIndex: 'nextMeetingDate',
      key: 'nextMeetingDate',
      render: (date) => <Tag color="blue">{formatDate(date)}</Tag>,
    },
    {
      title: 'Создано',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date) => formatDate(date),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={meetings}
      rowKey="_id"
      loading={loading}
      pagination={{ pageSize: 10 }}
      expandable={{
        expandedRowRender: (record) => (
          <div>
            <p><strong>Выводы:</strong> {record.summary}</p>
            <p><strong>Договорённости:</strong> {record.actionItems}</p>
          </div>
        ),
      }}
    />
  );
};

export default MeetingsTable;
